import React from 'react';
import { Card, Stack, Typography } from '@mui/material';
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';
import { IAudition } from '../../types/global/helper';
import { LightbulbCircleOutlined } from '@mui/icons-material';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { RichTextViewer } from '../Common/RichTextViewer';

export interface IAuditionDetail {
    audition: IAudition;
}

const AuditionDescription: React.FC<IAuditionDetail> = ({ audition }) => {
    const { themeStyle } = useThemeContext();
    return (
        <React.Fragment>
            <Stack direction="row" gap={1}>
                <LightbulbCircleOutlined sx={{ color: theme[themeStyle].tag_white }} />
                <Typography
                    sx={{
                        fontWeight: 'bold',
                        fontFamily: FONT_ENUM.MAIN_BOLD,
                        fontSize: 18,
                        color: theme[themeStyle].tag_white,
                    }}>
                    Project Description
                </Typography>
            </Stack>

            <Card
                sx={{
                    width: '100%',
                    borderRadius: 1,
                    overflow: 'visible',
                    my: 2,
                    p: 1,
                    height: 'fit-content',
                    backgroundColor: theme[themeStyle].secondaryBg,
                    border: `0.3px solid ${theme[themeStyle].highlight}`,
                }}>
                <RichTextViewer
                    content={audition.synopsis}
                    textStyle={{
                        fontSize: 14,
                        fontFamily: FONT_ENUM.MAIN_MEDIUM,
                        color: theme[themeStyle].tag_white,
                        padding: 0,
                    }}
                />
            </Card>
        </React.Fragment>
    );
};

export { AuditionDescription };
